import PlanStageAddEditPopup from "./planStageAddEditPopup";

export default class AddEditInvoicePopup extends PlanStageAddEditPopup {

    prepareInfo(info) {
        this.isPrel = info?.status === "PRE_CREATED";
        this.isEditing = info?.id;
        this.isNewOnPrel = false;

        this.clientInfo = globalThis.appPageView.state?.info || {};

        let dialogTitle = info?.isPre ? "newInvoicePreTitle" : "newInvoiceTitle";
        let date;
        let endTitle = "";

        if (this.isEditing || info?.parentInvoiceId) {
            const { id, doctorId, assistantId, comment, workItemId, parentInvoiceId, createdTime, domainId } = info;

            if ((!this.isPrel && workItemId && doctorId && assistantId) || (this.isPrel && id && doctorId && assistantId))
                this.state.step = 3;

            this.state.info = { id, comment, workItemId, doctorId, assistantId, parentInvoiceId, domainId };

            dialogTitle = this.isPrel ? (id ? "editPrelInvoiceTitle" : "newInvoiceTitle") : "editInvoiceTitle";
            date = createdTime;

            if (this.isPrel && !id) {
                this.isNewOnPrel = true;
                endTitle = this.tr("invoice.newInvoiceTitleEnd");
            }
        } else {
            const domainId = globalThis.appPageView.state?.clinicId;
            this.state.info = { domainId, isPre: info?.isPre ? true : false };
        }

        this.dialogTitle = `^${this.tr("invoice", dialogTitle)} ${this._helper.date.toDateStr(date)} ${endTitle}`;

        this.prepareSecondInfo(info);
    }

    async loadData() {
        this.visits = await this.getClientVisists(this.clientInfo.id, false, false);
    }

    changeVisit(id, visit) {
        const { doctorId, assistantId, domainId } = visit || {};
        const { info } = this.state;

        info.workItemId = id;
        info.doctorId = doctorId || null;
        info.assistantId = assistantId || null;
        info.domainId = domainId || null;

        this.setState({ info });
    }

    validateMainInfo() {
        const { id, doctorId, workItemId, assistantId } = this.state.info;

        if (this.isPrel && id)
            return !!doctorId;

        if (!doctorId || !workItemId || !assistantId) {
            let text = "Не выбран доктор";
            if (!workItemId)
                text = "Не выбран визит";
            else if (!assistantId)
                text = "Не выбран ассистент";

            this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("Не заполнены поля"),
                text,
            });
            return false;
        }

        return true;
    }

    changeStep(flag) {
        const n = this.isNewOnPrel ? 2 : 1;
        const step = this.state.step + (flag * n);

        this.setState({ step });
    }

    checkInfoBeforeSave(info) {
        return info;
    }

    getMiddleButton() {
        return <></>;
    }

    insertPrelInfo() {
        const { treatmentDirection, treatmentWorkStatus } = this._config;
        const { /*invoiceNumber,*/ createdTime, treatmentTask, parentInvoiceId: invoiceId, clientId } = this.info;

        /*const { invoiceId, clientId } = invoiceNumber || {};*/
        const { title, treatmentDirectionId, workStatus } = treatmentTask || {};

        const id = `${invoiceId}/${clientId}`;
        const from = this.tr("main.from2").toLowerCase();
        const created = this._helper.date.toDateStr(createdTime);

        const directItem = treatmentDirection.find(it => it.id === treatmentDirectionId);
        const direct = this.tr(directItem?.name || "main.notIndicated");

        const statusItem = treatmentWorkStatus.find(it => it.id === workStatus);
        const status = this.tr(statusItem?.name || "main.notIndicated");

        return (
            <>
                <div className="text p1 flex gap16">
                    <div className="rowInfoTitle">{this.tr("main.stage")}</div>
                    <div className="contentTitle">{title} {direct} / {status}</div>
                </div>
                <div className="text p1 flex gap16">
                    <div className="rowInfoTitle">{this.tr("treatmentPlan.provisionalBill")}</div>
                    <div className="contentTitle">{`${id} ${from} ${created}`}</div>
                </div>
            </>
        );
    }

    renderStepsHeader(step) {
        if (this.isNewOnPrel)
            return this.renderStepsShortHeader(step);

        return super.renderStepsHeader(step);
    }

    renderStepsShortHeader(step) {
        return (
            <div className="stepsHeader flex centerAll gap16">
                {this.insertStepsHeaderItem(1, 1, step, "treatmentPlan.totalInfo")}
                <div className="line"></div>
                {this.insertStepsHeaderItem(2, 3, step, "treatmentPlan.scopeWork")}
            </div>
        );
    }

    renderFirstStep() {
        const { doctorId, assistantId, comment, workItemId, domainId } = this.state.info;
        const patient = this._helper.string.formatFullName(this.clientInfo);
        const clinic = this._helper.getClinicNameById(domainId);

        return (
            <div className="flex col gap24">
                <div className="flex col gap8">
                    <div className="text p1 flex gap16">
                        <div className="rowInfoTitle">{this.tr("login.clinic")}</div>
                        <div className="contentTitle">{clinic}</div>
                    </div>
                    <div className="text p1 flex gap16">
                        <div className="rowInfoTitle">{this.tr("main.patient")}</div>
                        <div className="contentTitle">{patient}</div>
                    </div>
                    {this.isPrel && this.insertPrelInfo()}
                </div>
                <div className="flex1 flex gap24">
                    <div className="flex1 flex col gap16">
                        {this.insertSelectVisit({
                            value: workItemId,
                            label: "client.visit",
                            items: this.visits,
                            onChange: this.changeVisit.bind(this)
                        })}
                        {this.insertTextarea({
                            label: "invoice.invoiceComment",
                            placeHolder: "main.freeComment",
                            value: comment,
                            onChange: this.changeInfoState.bind(this, "comment")
                        })}
                    </div>
                    <div className="flex1 flex col gap24">
                        {this.insertSelectDoctor({
                            value: doctorId,
                            label: "client.doctor",
                            onClick: this.changeInfoState.bind(this, "doctorId")
                        })}
                        {this.insertSelectDoctor({
                            value: assistantId,
                            type: "assistent",
                            label: "client.assistant",
                            searchPlaceHolder: "main.searchAssist",
                            onClick: this.changeInfoState.bind(this, "assistantId")
                        })}
                    </div>
                </div>
            </div>
        );
    }

}
